import { useState } from "react";
import { useDispatch } from "./DataContext.js";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

const startName = "";
const startCode = "";

export default function NewPlayModal (props)
{
    const gDispatch = useDispatch();

    const [name, setName] = useState(startName);
    const [code, setCode] = useState(startCode);

    const codeValue = code.length < 3 ? code : code.substring(0, 3) + " " + code.substring(3, code.length);

    function hide ()
    {
	setName("");
	setCode("");
	props.hide();
    }

    
    function handleNameChange (e) { setName(e.target.value); }

    function handleCodeChange (e)
    {
	let nextCodeValue = e.target.value;
	if (nextCodeValue + " " === codeValue) nextCodeValue = nextCodeValue.substring(0, nextCodeValue.length-1);

	let nextCode = nextCodeValue.replace(/[^a-zA-Z0-9]+/g, "").toUpperCase();
	if (nextCode.length > 6) nextCode = nextCode.substring(0, 6);
	setCode(nextCode);
    }

    function newPlay ()
    {
	gDispatch({ type: "newPlay", name, code });
    }

    
    return (
	<Modal
	    show={props.show}
	    onHide={hide}
	    centered
	>
	    <Modal.Header className="bg-light" closeButton>
		<Modal.Title>Démarrer une nouvelle partie</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		{localStorage.getItem("playState") !== null && (<p className="fw-bold text-danger">Attention&nbsp;: si vous lancez une nouvelle partie, vous perdrez toute progression sauvegardée lors de votre partie en cours.</p>)}
		<Form className="d-flex flex-column gap-3 align-items-end">
		    <Form.Group className="w-100">
			<Form.Label>Les prénoms des membres de votre équipe</Form.Label>
			<Form.Control size="lg" type="text" maxLength="45" className="text-center" value={name} onChange={handleNameChange} aria-label="Prénoms des membres de votre équipe"/>
		    </Form.Group>
		    
		    <Form.Group className="w-100">
			<Form.Label>Le code d'accès (6&nbsp;caractères) fourni par votre enseignant</Form.Label>
			<Form.Control size="lg" type="text" placeholder="XXX XXX" className="text-center" value={codeValue} onChange={handleCodeChange} aria-label="Code d'accès fourni par votre enseignant"/>
		    </Form.Group>

		    <Button variant="primary" type="submit" disabled={name.length === 0 || code.length < 6} onClick={(e) => { e.preventDefault(); newPlay(); }}>Valider</Button>
		</Form>
	    </Modal.Body>
	</Modal>
    );
}

